import type { ConversionMode } from "@capcut-srt/core";
import { useLocale } from "../hooks/useLocale";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { ThemeSwitcher } from "./ThemeSwitcher";

interface HeaderProps {
  mode: ConversionMode;
  onModeChange: (mode: ConversionMode) => void;
  hasWordData: boolean;
  isIdle: boolean;
}

/**
 * Application header — eyebrow, title, mode control, language & theme switchers.
 */
export function Header({ mode, onModeChange, hasWordData, isIdle }: HeaderProps) {
  const { t } = useLocale();

  const wordDisabled = !hasWordData && !isIdle;

  return (
    <header className="topbar">
      <div className="topbar-brand">
        <a href="/" className="eyebrow">{t("header.eyebrow")}</a>
        <h1>{t("header.title")}</h1>
      </div>
      <div className="topbar-switchers">
        <LanguageSwitcher />
        <ThemeSwitcher />
      </div>
      <div className="mode-control" role="group" aria-label={t("aria.modeControl")}>
        <button
          className={mode === "segment" ? "active" : ""}
          onClick={() => onModeChange("segment")}
          type="button"
        >
          {t("header.modeSegment")}
        </button>
        <button
          className={mode === "word" ? "active" : ""}
          onClick={() => onModeChange("word")}
          type="button"
          disabled={wordDisabled}
          title={wordDisabled ? t("header.modeWordDisabled") : ""}
        >
          {t("header.modeWord")}
        </button>
      </div>
    </header>
  );
}
